

import Vue from 'vue';
import Component from 'vue-class-component';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/element.js';

// global_css
import './style.scss';

// echarts
import 'echarts-gl';
import VueEcharts from "vue-echarts-ts";
Vue.use(VueEcharts);


Vue.filter('dataFormat', (input: string, pattern = '') => {
  const dt = new Date(input);
  // 获取年月日
  const y = dt.getFullYear();
  const M = (dt.getMonth() + 1).toString().padStart(2, '0');
  const d = dt.getDate().toString().padStart(2, '0');
  const hh = dt.getHours().toString().padStart(2, '0');
  const mm = dt.getMinutes().toString().padStart(2, '0');
  const ss = dt.getSeconds().toString().padStart(2, '0');
  // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
  // 否则，就返回  年-月-日 时：分：秒
  if (pattern === 'yyyy/MM/dd') {
    return `${y}/${M}/${d}`;
  } else if (pattern === 'HH:mm:ss') {
    return `${hh}:${mm}:${ss}`;
  } else if (pattern === '年月日') {
    return `${y}年${M}月${d}日`;
  } else {
    return `${y}-${M}-${d} ${hh}:${mm}:${ss}`;
  }
});

// add Custom Vue Router Hooks
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
]);


Vue.config.productionTip = false;



new Vue({
  router,
  store,
  render: (h) => {
    // 搭建环境变量
    if (process.env.NODE_ENV === "development") {
      window.OPTION = {
        项目名称: "儿童体质健康大数据平台",
        登录页名称1: "儿童体质健康大数据平台",
        登录页名称2: "",
        关键词: "医案",
        小程序名称: "小儿体质数据管理平台",
      };
      window.qrsrc = "/sjzx/二维码-河南.jpg";
      document.title = "儿童体质健康大数据平台";
    } else if (process.env.VUE_APP_ENV === "test") {
      window.OPTION = {
        项目名称: "儿童体质健康大数据平台",
        登录页名称1: "儿童体质健康大数据平台",
        登录页名称2: "",
        关键词: "医案",
        小程序名称: "小儿体质数据管理平台",
      };
      window.qrsrc = "/sjzx/二维码-河南.jpg";
      document.title = "儿童体质健康大数据平台";
    } else if (process.env.VUE_APP_ENV === "production") {
      window.OPTION = {
        项目名称: "儿童体质健康大数据平台",
        登录页名称1: "儿童体质健康大数据平台",
        登录页名称2: "",
        关键词: "医案",
        小程序名称: "小儿体质数据管理平台",
      };
      window.qrsrc = "/sjzx/二维码-河南.jpg";
      document.title = "儿童体质健康大数据平台";
    }
    return h(App);
  },
}).$mount('#app');
